import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const taskDetail = async (params: object) => {
  return await GET({ url: Api.taskDetail, params, showError: false })
}
